import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function Baths(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.baths().length) {
    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  if (!listing.baths) {
    return false;
  }

  // Determine if the listing matches the filter.
  const _value = this.filteringService.baths().map((b) => parseInt(b, 10));
  if (!_value.includes(listing.baths.full)) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
